import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faBan, faCircleCheck, faPage } from "@fortawesome/pro-regular-svg-icons";

import { FooterActionItem } from "./FooterActionItem";
import { FooterPopoverGroup } from "./FooterPopoverGroup";
import { TableFooterProps } from "./table-footer.types";

interface FooterBlacklistGroupProps {
	removeFromBlacklist?: TableFooterProps["removeFromBlacklist"];
	unflagCompetitor?: TableFooterProps["unflagCompetitor"];
	isOpen: boolean;
	onToggle: () => void;
	onAction: () => void;
}

/**
 * The bulk bar's blacklist group: taking a contact off the blacklist, and
 * clearing a company's competitor flag (which is its own kind of un-blocking —
 * a competitor is blacklisted account-wide).
 *
 * Extracted from `TableFooter`, which is over the length ratchet.
 */
export const FooterBlacklistGroup: FunctionComponent<FooterBlacklistGroupProps> = ({
	removeFromBlacklist,
	unflagCompetitor,
	isOpen,
	onToggle,
	onAction,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`basics.${key}`);

	const isLoading = !!(
		removeFromBlacklist?.removeFromBlacklistIsLoading || unflagCompetitor?.unflagCompetitorIsLoading
	);

	return (
		<FooterPopoverGroup
			dark
			icon={faBan}
			isLoading={isLoading}
			isOpen={isOpen}
			label={ts("blacklist")}
			loadingLabel={ts("wait")}
			onToggle={onToggle}
		>
			{removeFromBlacklist && (
				<FooterActionItem
					icon={faPage}
					isMenuItem
					label="Remove from Blacklist"
					onClick={() => {
						removeFromBlacklist?.removeFromBlacklist?.();
						onAction();
					}}
				/>
			)}

			{unflagCompetitor && (
				<FooterActionItem
					icon={faCircleCheck}
					isMenuItem
					label={unflagCompetitor.label}
					onClick={() => {
						unflagCompetitor?.unflagCompetitor?.();
						onAction();
					}}
				/>
			)}
		</FooterPopoverGroup>
	);
};
